// TODO: Move this to RSUI
import React from 'react';
import PropTypes from 'prop-types';

import { TablePagination as TablePaginationMUI } from '@material-ui/core';

const defaultLabelDisplayedRows = ({ from, to, count }) => {
  return `Showing ${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`;
};

// Note: Manually add 'variant' (outlined, filled, etc.) styling for 'select' (rows per page)
// since we can't specify it via props
const TablePagination = ({ children, ...props }) => {
  return (
    <TablePaginationMUI
      labelDisplayedRows={defaultLabelDisplayedRows}
      SelectProps={{
        inputProps: { 'aria-label': 'rows per page' },
        native: true,
      }}
      {...props}
    >
      {children}
    </TablePaginationMUI>
  );
};

TablePagination.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

TablePagination.defaultProps = {};

export default TablePagination;
